<template>
  <div class="deal-banner-bg" v-if="isActive">
  <div class="container-max">
    <div class="deal-banner d-none d-md-flex">
      <div class="deal-banner__countdown">
        <div class="time-box">
          <span class="time-box__value">{{ formattedTime.days }}</span>
          <span class="time-box__label">DAYS</span>
        </div>

        <span class="time-separator">:</span>

        <div class="time-box">
          <span class="time-box__value">{{ formattedTime.hours }}</span>
          <span class="time-box__label">HRS</span>
        </div>

        <span class="time-separator">:</span>

        <div class="time-box">
          <span class="time-box__value">{{ formattedTime.minutes }}</span>
          <span class="time-box__label">MINS</span>
        </div>
      </div>

      <div class="deal-banner__content">
        <div class="deal-banner__headline">
          {{ dealName.toUpperCase() }}:
        </div>

        <div class="deal-banner__text">
          {{ description }}
        </div>
      </div>

      <button
          class="deal-banner__code"
          :class="{ 'deal-banner__code--copied': copied }"
          type="button"
          @click="copyCode"
      >
        {{ copied ? copiedText : code }}
      </button>
    </div>

    <div class="deal-banner d-md-none">
      <div class="deal-banner__content">
        <div class="deal-banner__headline">
          {{ dealName.toUpperCase() }}:
        </div>

        <div class="deal-banner__text">
          {{ description }}
        </div>
      </div>

      <div class="d-flex deal-banner__mobile-content">
        <div class="deal-banner__countdown">
          <div class="time-box">
            <span class="time-box__value">{{ formattedTime.days }}</span>
            <span class="time-box__label">DAYS</span>
          </div>

          <span class="time-separator">:</span>

          <div class="time-box">
            <span class="time-box__value">{{ formattedTime.hours }}</span>
            <span class="time-box__label">HRS</span>
          </div>

          <span class="time-separator">:</span>

          <div class="time-box">
            <span class="time-box__value">{{ formattedTime.minutes }}</span>
            <span class="time-box__label">MINS</span>
          </div>
        </div>
        <button
            class="deal-banner__code"
            :class="{ 'deal-banner__code--copied': copied }"
            type="button"
            @click="copyCode"
        >
          {{ copied ? copiedText : code }}
        </button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'DealBanner',
  props: {
    dealName: {
      type: String,
      default: 'STEP-UP DEAL'
    },
    description: {
      type: String,
      default: '10% extra Rabatt auf alle K1 Walking Pads mit dem Code'
    },
    code: {
      type: String,
      default: 'STEPUP10'
    },
    endDate: {
      type: [String, Number, Date],
      required: true
    },
    copiedText: {
      type: String,
      default: 'KOPIERT!'
    }
  },
  data() {
    return {
      timer: null,
      copied: false,
      remainingMs: 0
    };
  },
  computed: {
    formattedTime() {
      const totalSeconds = Math.max(0, Math.floor(this.remainingMs / 1000));

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);

      return {
        days: this.pad(days),
        hours: this.pad(hours),
        minutes: this.pad(minutes)
      };
    },
    isActive() {
      return this.remainingMs > 0;
    }
  },
  mounted() {
    this.updateCountdown();
    this.timer = setInterval(this.updateCountdown, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    pad(value) {
      return String(value).padStart(2, '0');
    },
    updateCountdown() {
      const end = new Date(this.endDate).getTime();
      const now = Date.now();
      this.remainingMs = Math.max(0, end - now);

      if (this.remainingMs <= 0 && this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async copyCode() {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.code);
        } else {
          this.fallbackCopyText(this.code);
        }

        this.copied = true;

        setTimeout(() => {
          this.copied = false;
        }, 1800);

        this.$emit('copied', this.code);
      } catch (error) {
        console.error('Code konnte nicht kopiert werden:', error);
      }
    },
    fallbackCopyText(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }
  }
};
</script>